<template>

  <m-pay-layout>
    <v-layout justify-space-around :column="$vuetify.breakpoint.smAndDown">
      <v-flex>
          <v-card class="mb-3 mx-2">

            <v-card-text>
              <div>
                <div class="title">
                  {{ shippingMethod.name }}
                </div>

                <br/>
                <div>Created at
                  <span class="body-2">
                    {{ formatters.dateTime(shippingMethod.createdAt) }}
                  </span>
                  by
                  <v-chip small color="primary" text-color="white">
                    <v-avatar>
                      <v-icon>account_circle</v-icon>
                    </v-avatar>
                    {{ shippingMethod.createdBy }}
                  </v-chip>
                </div>
                <div>Updated at
                  <span class="body-2">
                    {{ formatters.dateTime(shippingMethod.updatedAt) }}
                  </span>
                  by
                  <v-chip small color="primary" text-color="white">
                    <v-avatar>
                      <v-icon>account_circle</v-icon>
                    </v-avatar>
                    {{ shippingMethod.updatedBy }}
                  </v-chip>
                </div>
                <div>Active
                  <v-chip small
                    :color="merchantShippingMethodStatusClasses[shippingMethod.enabled]"
                    text-color="white">
                    <v-avatar>
                      <v-icon>check_circle</v-icon>
                    </v-avatar>
                    {{ shippingMethod.enabled ? "Yes" : "No" }}
                  </v-chip>
                </div>
              </div>
            </v-card-text>

          </v-card>
          <v-card class="mb-3 mx-2">
            <v-card-title>
              <span class="headline">Actions</span>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="shippingMethod.enabled" large flat color="secondary"
                     class="mx-2" :loading="loading"
                     :disabled="loading"
                     @click.prevent="disableMethod">
                Disable method
                <v-icon right dark>toggle_off</v-icon>
              </v-btn>
              <v-btn v-if="!shippingMethod.enabled" large flat color="secondary"
                     class="mx-2" :loading="loading"
                     :disabled="loading"
                     @click.prevent="activateMethod">
                Activate method
                <v-icon right dark>toggle_off</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-flex>

      <v-flex>
        <v-card class="mb-3 mx-2">
          <v-card-title>
            <span class="headline">Update Shipping Method</span>
          </v-card-title>

          <m-pay-shipping-method-editor
            :shippingMethod="shippingMethod"
            :loading="loading"
            @cancel="cancel"
            @submit="updateMethod"
          />

        </v-card>
      </v-flex>
    </v-layout>

  </m-pay-layout>

</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayShippingMethodEditor from './MPayShippingMethodEditor';
import formatters from '../../utils/formatters';
import { merchantShippingMethodStatusClasses } from '../../utils/statuses';

export default {
  name: 'MPayMerchantShippingMethodCreateView',

  components: { MPayShippingMethodEditor },

  data: () => ({
    shippingMethod: {
      id: '',
      name: '',
      extId: '',
      methodId: '',
    },
    loading: false,
    formatters,
    merchantShippingMethodStatusClasses,
  }),

  methods: {
    cancel() {
      this.$router.push({ name: 'shipping-methods' });
    },
    updateMethod(method) {
      this.loading = true;
      axios.put(queries.updateMerchantShippingMethod(), method)
        .then(() => {
          this.loading = false;
          this.showSuccessMessage('Shipping method successfully updated');
        })
        .catch((e) => {
          this.handleError(e);
        });
    },
    activateMethod() {
      this.loading = true;
      axios.put(queries.activateMerchantShippingMethod(this.shippingMethod.id))
        .then(() => {
          this.loading = false;
          this.showSuccessMessage('Shipping method successfully activated');
          this.shippingMethod.enabled = true;
        })
        .catch((e) => {
          this.handleError(e);
        });
    },
    disableMethod() {
      this.loading = true;
      axios.put(queries.disableMerchantShippingMethod(this.shippingMethod.id))
        .then(() => {
          this.loading = false;
          this.showSuccessMessage('Shipping method successfully disabled');
          this.shippingMethod.enabled = false;
        })
        .catch((e) => {
          this.handleError(e);
        });
    },
    handleError(e) {
      this.showError(e);
      this.loading = false;
    },
    fetchMerchantShippingMethod(msmId) {
      if (this.$route.query.created) {
        this.showSuccessMessage('Widget successfully created');
      } else {
        this.loading = true;
        axios.get(queries.merchantShippingMethod(msmId))
          .then((response) => {
            this.shippingMethod = response.data;
            this.loading = false;
          })
          .catch((e) => {
            this.showError(e);
            this.loading = false;
          });
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.fetchMerchantShippingMethod(this.$route.params.id);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantShippingMethodUpdateView.vue